import {
  getMessageList,
  getMessageInfo,
  getMessageCount,
  sendMessage,
  customerEvaluate
} from '@/api/message.js'

const state = {
}

const mutations = {
}

const actions = {
  getMessageList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMessageList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMessageInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMessageInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  sendMessage({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      sendMessage(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMessageCount({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMessageCount(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  customerEvaluate({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      customerEvaluate(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
